import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getAuthUserId } from '../../../data/auth/authSelectors'
import { useLazyGetClientEpisodesQuery } from '../../episodes/data/episodesApi'

const useGetRelId = () => {
  const [getClientEpisodes] = useLazyGetClientEpisodesQuery()
  const userId = useSelector(getAuthUserId)
  return useCallback(
    async (clientId: string | null) => {
      if (!clientId) {
        return null
      }

      const episodes = await getClientEpisodes({ patientId: clientId, providerId: userId }).unwrap()
      return episodes.find((episode) => episode.patient_id === clientId)?.provider_patient_id ?? null
    },
    [getClientEpisodes, userId],
  )
}

export default useGetRelId
